export default {
  buy: [{
    key: true,
    value: true,
    label: 'Show',
  }, {
    key: false,
    value: false,
    label: 'Hide',
  }],
  press: [{
    key: true,
    value: true,
    label: 'Show',
  }, {
    key: false,
    value: false,
    label: 'Hide',
  }],
  social: [{
    key: true,
    value: true,
    label: 'Show',
  }, {
    key: false,
    value: false,
    label: 'Hide',
  }],
};
